import { create } from "zustand";
import { devtools } from "zustand/middleware";
// import useLoaderStore from "./useLoaderStore";
// import { useToastStore } from "./toastStore";

interface AuthState {
	token: string | null;
	setToken: (token: string) => void;
	negotiation_id: string;
	setNegotiationId: (id: string) => void;
	// getUserIdentity: () => Promise<void>;
}

const getInitialToken = () => {
	if (typeof window === "undefined") return "";
	try {
		const raw = window.localStorage.getItem("token");
		return raw ? JSON.parse(raw) : "";
	} catch {
		return "";
	}
};

export const useAuthStore = create<AuthState>()(
	devtools(
		(set) => ({
			token: getInitialToken(),
			negotiation_id: "",
			setToken: (token) => set({ token }),
			setNegotiationId: (id: string) => set({ negotiation_id: id }),
			// getUserIdentity: async () => {
			// 	const { showLoader } = useLoaderStore.getState();
			// 	const { error } = useToastStore.getState();
			// 	const token = useAuthStore.getState().token;
			// 	const url = import.meta.env.VITE_API_BASE_URL;
			// 	showLoader(true);
			// 	const params = "api/v1/auth/identity";
			// 	try {
			// 		const resp = await fetch(
			// 			url + params,
			// 			{
			// 				method: "GET",
			// 				headers: {
			// 					Authorization: `Bearer ${token}`,
			// 				},
			// 				credentials: 'include'
			// 			}
			// 		);
			// 		const data = await resp.json();
			// 		if (!data?.email) {
			// 			error(
			// 				"Error",
			// 				`Failed to fetch user identity: ${data?.message}`
			// 			);
			// 			return null;
			// 		}
			// 		return data;
			// 	} catch (err) {
			// 		showLoader(false);
			// 		console.log(err);
			// 	} finally {
			// 		showLoader(false);
			// 	}
			// },
		}),
		{ name: "auth-storage" }
	)
);

export const setAuthToken = (jwt: string) => useAuthStore.getState().setToken(jwt);
